import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { API_VALIDATED_FIELDS } from '../constants/fields'

export function useLogUnhandledAPIErrors() {
  const logger = useLogger()

  const logUnhandledAPIErrors = (fields: Array<string> = []) => {
    fields.forEach((field: string) => {
      if (!API_VALIDATED_FIELDS.includes(field)) {
        logger.error(`[Checkout] Unhandled address field: ${field}`, {
          owners: ['bot-squad-checkout-front'],
        })
      }
    })
  }

  return { logUnhandledAPIErrors }
}
